export const valuesExtProducto = {
    'DENTAL': 1,
    "SEGURO SALUD": 2,
    "SENIORS": 3,
    "SEGURO ACCIDENTES": 4,
    "MASCOTAS": 5,
    "DENTAL MAX ": 6,
    "ADESLAS GO ": 7,
    "ADESLAS VITAL": 8,
    "ADESLAS PLENA": 9,
    "ADESLAS PLENA PLUS": 10,
    "ADESLAS SENIOR": 11,
    "ADESLAS EXTRA 150 MIL": 12,
    "DECESOS TODO PREVISTO": 13,
    "ACCIDENTES COMPLETO": 14,
    "DENTAL COMPLEMENTARIO": 15,
    "MASCOTAS BASICO": 16,
    "MASCOTAS COMPLETO": 17,
    "DECESOS": 18,
    "AUTONOMOS": 19,
    "ADESLAS PLENA TOTAL": 20,
    "Autónomos SALUD + DECESOS": 21,
    "Autónomos SALUD + MASCOTAS": 22,
    "Autónomos SALUD + MASCOTAS + DECESOS": 23,
    "Autónomos DENTAL + DECESOS": 24,
    "Autónomos DENTAL + MASCOTAS": 25,
    "Autónomos DENTAL + MASCOTAS + DECESOS": 26,
    "Autónomos SALUD y DENTAL + MASCOTAS": 27,
    "Autónomos SALUD y DENTAL + MASCOTAS + DECESOS": 28,
    "MASCOTAS + SALUD": 29,
    "MASCOTAS + DENTAL": 30,
    "MASCOTAS + DECESOS": 31,
    "MASCOTAS + SALUD + DENTAL": 32,
    "MASCOTAS + SALUD + DENTAL + DECESOS": 33,
    "MASCOTAS + SALUD + DECESOS": 34,
    "MASCOTAS + DENTAL + DECESOS": 35,
    "Funcionarios EXTRA SALUD": 36,
    "ADESLAS GO + DENTAL": 37,
    "Autónomos SALUD + DENTAL": 38
}